import { data } from "component/common/Plugins/devExpressScheduler/data";
import React, { Component } from "react";
import { ImCheckboxUnchecked, ImCheckboxChecked } from "react-icons/im";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import "./style.scss";
import { transactionSettingListAct } from "redux/actions/transactionHistory";
import { commonPatchApi, getCommonApi } from "redux/actions/common";
export class TranscationSettingClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkBoxList: [],
    };
  }

  componentDidMount = async () => {
    if (this.props.transactionSettingList) {
      await this.setState({ checkBoxList: this.props.transactionSettingList });
    }
  };

  // handleChangeCheckBox
  handleChangeCheckbox = (list) => {
    let { id, name, checked, type } = list;
    let payload = { name: name, checked: !checked, type: type };
    this.props
      .commonPatchApi(`invoicetemplateconfig/${id}/`, payload)
      .then((key) => {
        let { status } = key;
        if (status == "200") {
          this.getInvoiceSettingList();
        }
      });
  };

  // getInvoiceSettingList
  getInvoiceSettingList = () => {
    this.props.getCommonApi(`invoicetemplateconfig/`).then(async (res) => {
      let { data, status } = res;
      if (status == 200) {
        if (data && data.length > 0) {
          let filterOriginalList = data;
          console.log(filterOriginalList, "filterOriginalList_Setting");
          const modifiedList = filterOriginalList.reduce(
            (result, item) => {
              result[item.type].push(item);
              return result;
            },
            { headerList: [], footerList: [], bodyList: [] }
          );
          let filterList = [];
          filterList.push(modifiedList);
          this.setState({ checkBoxList: filterList });
          this.props.transactionSettingListAct(filterList);
        }
      }
    });
  };

  render() {
    let { checkBoxList } = this.state;
    return (
      <>
        <div className="container-fluid p-3 transactionSetting mt-2 mt-sm-5">
          <h6 className="mb-5 mb-sm-3 m-3 ">Transaction Setting</h6>

          <div className="row mt-4 m-3 ">
            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-6 ">
              <div className="row checkboxBoxShadow">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                  <h6>Header</h6>
                  {checkBoxList && checkBoxList.length > 0 && (
                    <div className="row ">
                      {checkBoxList?.map((item, index) => (
                        <>
                          {item.headerList.map((list, ix) => (
                            <div className="col-md-12 " key={ix}>
                              <div className="d-flex align-items-center checboxList">
                                {list.checked ? (
                                  <ImCheckboxChecked
                                    onClick={() =>
                                      this.handleChangeCheckbox(list)
                                    }
                                    size={20}
                                    color="green"
                                    className="checkboxIcon"
                                  />
                                ) : (
                                  <ImCheckboxUnchecked
                                    size={20}
                                    color="green"
                                    onClick={() =>
                                      this.handleChangeCheckbox(list)
                                    }
                                    className="checkboxIcon"
                                  />
                                )}

                                <h6 className="mb-0 ml-3">{list.name}</h6>
                              </div>
                            </div>
                          ))}
                        </>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6  ">
                  <h6>Footer</h6>
                  <div className="row">
                    {checkBoxList?.map((item, index) => (
                      <>
                        {item.footerList.map((list, ix) => (
                          <div className="col-md-12 " key={ix}>
                            <div className="d-flex align-items-center checboxList">
                              {list.checked ? (
                                <ImCheckboxChecked
                                  onClick={() =>
                                    this.handleChangeCheckbox(list)
                                  }
                                  size={20}
                                  color="green"
                                  className="checkboxIcon"
                                />
                              ) : (
                                <ImCheckboxUnchecked
                                  size={20}
                                  color="green"
                                  onClick={() =>
                                    this.handleChangeCheckbox(list)
                                  }
                                  className="checkboxIcon"
                                />
                              )}

                              <h6 className="mb-0 ml-3">{list.name}</h6>
                            </div>
                          </div>
                        ))}
                      </>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row mt-3 mt-sm-2"></div>
            </div>
            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-6 ">
              <div className="checkboxBoxShadow">
                <h6>Body</h6>
                <div className="row">
                  {checkBoxList?.map((item, index) => (
                    <>
                      {item.bodyList.map((list, ix) => (
                        <div className="col-md-6" key={ix}>
                          <div className="d-flex align-items-center  checboxList">
                            {list.checked ? (
                              <ImCheckboxChecked
                                onClick={() => this.handleChangeCheckbox(list)}
                                size={20}
                                color="green"
                                className="checkboxIcon"
                              />
                            ) : (
                              <ImCheckboxUnchecked
                                size={20}
                                color="green"
                                onClick={() => this.handleChangeCheckbox(list)}
                                className="checkboxIcon"
                              />
                            )}

                            <h6 className="mb-0 ml-3">{list.name}</h6>
                          </div>
                        </div>
                      ))}
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  transactionSettingList: state.transactionStore.transactionSettingList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      transactionSettingListAct,
      commonPatchApi,
      getCommonApi,
    },
    dispatch
  );
};

export const TranscationSetting = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TranscationSettingClass)
);
